import React from 'react';
import FieldUser_DeletedUsersMenuOption from "./menu-option";
import VScroll from "../../../../../gd-components/scrolling/custom-v-scroll/v-scroll";
import FieldProto from "../../../../proto/field-proto";
import FieldUserAndDeleted from "../../user-and-deleted";

export default function FieldUser_DeletedUsersMenu(field: FieldUserAndDeleted, onSelectOption: callback, currentOption: Option, highlightedOption: Option) {

    if (field.getDeletedUsersOptions().length === 0) {
        return (
            <div className="ui5-popover-menu">
                <div className="ui5-txt-not-important-small p-h-20 p-t-10 p-b-10">
                    No deleted users found.
                </div>
            </div>
        )
    }

    return (
        <div className="ui5-popover-menu ">
            <VScroll containerClass     = "max-h-500"
                     minDragHeight      = {20}
                     scrollVisibility   = "auto"
            >

                {field.getDeletedUsersOptions().map((option: Option, key: number)=> {

                    return <FieldUser_DeletedUsersMenuOption key                = {key}
                                                             option             = {option}
                                                             currentOption      = {currentOption}
                                                             highlightedOption  = {highlightedOption}
                                                             onSelectOption     = {onSelectOption}/>
                })}

            </VScroll>
        </div>
    );
}
